export default "__VITE_ASSET__DnS$$N15__"